const googleTranslateConfig = {
	lang: Shopify.locale,
	// testWord: "Язык",
	// langFirstVisit: 'en',
	// domain: "Get-Web.Site"
};

console.log(googleTranslateConfig)

$(function () {
	let script = document.createElement("script");
	script.src = `//translate.google.com/translate_a/element.js?cb=TranslateWidgetIsLoaded`;
	document.getElementsByTagName("head")[0].appendChild(script);
});

function TranslateWidgetIsLoaded() {
	TranslateInit(googleTranslateConfig);
}

function TranslateInit(config) {
	if (config.langFirstVisit && !$.cookie("googtrans")) {
		TranslateCookieHandler("/auto/" + config.langFirstVisit);
	}

	let code = TranslateGetCode(config);

	TranslateHtmlHandler(code);

	if (code == config.lang) {
		TranslateCookieHandler(null, config.domain);
	}

	if (config.testWord) TranslateMutationObserver(config.testWord, code == config.lang);


	new google.translate.TranslateElement({
		pageLanguage: config.lang,
		multilanguagePage: true, 
	});
	$("[data-google-lang]").click(function () {
		TranslateCookieHandler(
			"/auto/" + $(this).attr("data-google-lang"),
			config.domain
		);
		if(!isMobileDevice()) {
			$('#custom-hoverdown-update-button')?.trigger('update_currency_lang')
		}
		setTimeout(() => {
			window.location.reload();
		}, 500);
	});
}

function TranslateGetCode(config) {
	let lang =
		$.cookie("googtrans") != undefined && $.cookie("googtrans") != "null"
			? $.cookie("googtrans")
			: config.lang;
	return lang.match(/(?!^\/)[^\/]*$/gm)[0];
}

function TranslateCookieHandler(val, domain) {
      var domain = location.host.replace(/^www\./, '.');
      document.cookie = `googtrans=${val}; path=/`;
      document.cookie = `googtrans=${val}; domain=${domain}; path=/`;
}

function TranslateHtmlHandler(code) {
   if(!code) return;
   const customCurrencySelect = document.querySelector(
      "#custom-select-langMobileNav"
    );
    customCurrencySelect?.init();
    customCurrencySelect?.selectOption($(`[data-google-lang=${code}]`).get(0));
}


function TranslateMutationObserver(word, isOrigin) {

	if (isOrigin) {
		document.dispatchEvent(new CustomEvent("FinishTranslate"));
	} else {
		let div = document.createElement('div');
		div.id = 'googleTranslateTestWord';
		div.innerHTML = word;
		div.style.display = 'none';
		document.body.prepend(div);

		let observer = new MutationObserver(() => {
			document.dispatchEvent(new CustomEvent("FinishTranslate"));
			observer.disconnect();
		});

		observer.observe(div, {
			childList: false,
			subtree: true,
			characterDataOldValue: true
		});
	}
}